module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "layout-header"
  }, [_c('div', {
    staticClass: "layout-header-inner"
  }, [_c('nav', {
    staticClass: "header-nav"
  }, [_c('div', {
    staticClass: "login_left"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/images/client/logo.png"),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "menu_tabs"
  }, [_c('tabs')], 1)]), _c('div', {
    staticClass: "login_right"
  }, [(_vm.profile && _vm.profile.userName) ? _c('div', {
    staticClass: "info"
  }, [_c('el-dropdown', [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("欢迎 " + _vm._s(_vm.profile.userName || 'xxx'))]), _c('img', {
    staticClass: "drop",
    attrs: {
      "src": require("../../assets/images/client/drop.png"),
      "alt": ""
    }
  })]), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', [_c('div', {
    staticClass: "box",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.logout($event)
      }
    }
  }, [_c('i', {
    staticClass: "logoOut"
  }), _vm._v("登出\n                ")])])], 1)], 1)], 1) : _c('div', {
    staticClass: "btns"
  }, [_c('el-button', {
    staticClass: "px-10 btn-blue",
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("登录")])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-02740f5b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/Header.vue
// module id = 401
// module chunks = 0